export function VortioBadge() {
  return (
    <a
      href="https://vortio.com"
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center gap-2.5 rounded-full border border-primary-foreground/15 bg-primary-foreground/[0.04] px-3 py-1.5 backdrop-blur-sm transition-colors hover:border-primary-foreground/30 hover:bg-primary-foreground/[0.08]"
    >
      <span className="relative inline-flex h-7 w-7 items-center justify-center">
        <svg
          viewBox="0 0 40 40"
          className="absolute inset-0 h-full w-full"
          aria-hidden="true"
        >
          {/* Orbiting arcs around the V */}
          <g className="vortio-orbit-cw" style={{ transformOrigin: "20px 20px" }}>
            <circle
              cx="20"
              cy="20"
              r="16"
              fill="none"
              stroke="oklch(0.75 0.15 70)"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeDasharray="14 86"
            />
          </g>
          <g className="vortio-orbit-ccw" style={{ transformOrigin: "20px 20px" }}>
            <circle
              cx="20"
              cy="20"
              r="13"
              fill="none"
              stroke="oklch(0.65 0.12 210)"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeDasharray="8 74"
            />
          </g>
          {/* The V */}
          <path
            d="M11 14 L20 28 L29 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-primary-foreground"
          />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className="text-[8px] uppercase tracking-[0.18em] text-primary-foreground/50">
          Designed by
        </span>
        <span className="text-xs font-semibold tracking-wider text-primary-foreground">
          VORTIO
        </span>
      </span>
    </a>
  );
}
